module.exports = __webpack_public_path__ + "img/電気回路_4_2_4.a223dea0.png";